import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import green from '@material-ui/core/colors/green';
import Fab from '@material-ui/core/Fab';
import PlayArrowSharpIcon from '@material-ui/icons/PlayArrowSharp';
import StopSharpIcon from '@material-ui/icons/StopSharp';
import {useDispatch, useSelector} from "react-redux";
import {setStromboliOff, setStromboliOn} from "../../../../actions";
import {Badge} from "reactstrap";
import IntlMessages from "../../../../util/IntlMessages";
import {Box, Card, Grid} from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {
  BBDisableChildren,
  bbDoesCustomerHaveAccessToModule,
  bbGetModulePropertyFromIdOrName,
  BBModuleIcon, isCurrentUserMemberOf
} from "../../../../util/bbHelpers";

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
    // textAlign: 'center'
  },
  fabProgress: {
    color: green[500],
    position: 'absolute',
    top: -6,
    left: -6,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
});

const CIRTControlButton = (props) => {

  const {
    classes,
    customerId,
    requiresModule = "perimeter",
    overrideEnabledForAdminsStaff = false,
  } = props;
  const {customers, loadingStromboli} = useSelector(({customer}) => customer);
  const {authUser} = useSelector(({auth}) => auth);
  const isAdminStaff = isCurrentUserMemberOf(authUser, "admin") || isCurrentUserMemberOf(authUser, "staff")
  //const [loading, setLoading] = useState(null);
  // const [success, setSuccess] = useState(null);
  const [customer, setCustomer] = useState(customers ? customers[customerId] : null);
  const [isStromboliActive, setIsStromboliActive] = useState(customer ? customer.Stromboli ? customer.Stromboli["Service Active"] === "1" : null : null);



  const dispatch = useDispatch();

  useEffect(() => {
    if (customers && customerId) {
      //setLoading(false);

      setCustomer(customers[customerId]);
      if (customer) {
        setIsStromboliActive(customer ? customer.Stromboli ? customer.Stromboli["Service Active"] === "1" : null : null);
      }

    }
  }, [customer, isStromboliActive, loadingStromboli, customerId, customers]);

  const handleButtonClick = (event) => {
    if (!loadingStromboli) {
      //setLoading(true);
      //TODO: handle the requerst then set loading to false and success
      if (customer) {
        if (isStromboliActive) {
          console.log("Attempting to set Stromboli Off for customer ", customers[customerId])
          dispatch(setStromboliOff(customerId));
        } else {
          console.log("Attempting to set Stromboli On for customer ", customers[customerId])
          dispatch(setStromboliOn(customerId));
        }
      }
    }
  };
  // timer = undefined;


  const buttonClassname = () => {
    if (!isStromboliActive && customers && !loadingStromboli) {
      return "bg-bb-risk-medium text-dark"
    } else if (isStromboliActive && customers && !loadingStromboli) {
      return "bg-bb-risk-lowest text-white"
    } else {
      return "bg-light text-dark"
    }
  };

  return ( <div>

          <Card className={`bg-light animated fadeIn animation-duration-5 d-flex flex-row`} style={{borderLeft: "12px solid gray", padding: "3px", paddingTop: "7px"}}>

              <Grid container
                    spacing={0}
                    alignItems="stretch"
                    justifyContent="center"
                    direction="row"
              >
                <Grid item xs={4}>

                  <Box className={classes.wrapper}>
                    <BBDisableChildren
                        isDisabled={requiresModule ? (overrideEnabledForAdminsStaff && isAdminStaff) ? true : bbDoesCustomerHaveAccessToModule(customer, requiresModule) : true}
                        moduleRequired = {requiresModule ? requiresModule : null}
                        isCompact
                        isButtonSized
                    >
                    <Tooltip title={isStromboliActive ? "Disable Continuous Attacks" : "Enable Continuous Attacks"}>
                      <Fab color="default" className={buttonClassname()} onClick={(event) => handleButtonClick(event)}>
                        {isStromboliActive ? <StopSharpIcon/> : <PlayArrowSharpIcon/>}
                      </Fab>
                    </Tooltip>
                    {(loadingStromboli || !customers) && <CircularProgress size={68} className={classes.fabProgress}/>}
                    </BBDisableChildren>
                  </Box>

                  {/*<h5 style={{fontSize: "smaller"}}>Control:</h5>*/}
                </Grid>
                <Grid item xs={8} >
                      <h2 >Continuous Attacks</h2>
                      <Box >Status: {(customer && !loadingStromboli) ? isStromboliActive ? <Badge color="bb-risk-lowest"><IntlMessages id={"badge.cirt.active"}/></Badge> : <Badge color="bb-risk-medium"><IntlMessages id={"badge.cirt.inactive"}/></Badge> : <small> <em>Retrieving...</em></small>}</Box>

                </Grid>
              </Grid>
              <div style={{marginLeft: "auto", marginTop: "-6px", marginRight: "3px"}}>
                <BBModuleIcon includeTooltip module={bbGetModulePropertyFromIdOrName("perimeter", "id")} isActive={bbDoesCustomerHaveAccessToModule(customer, "perimeter")} iconSize={"22px"}/>
              </div>
              <div style={{marginLeft: "auto", marginTop: "-6px"}}>
                <Tooltip title={"CIRT Continuous Attacks Control: When enabled, Continuous Intelligent Red Team engine conducts active intrusion attempts on your company.  You can disable and enable this feature at any time.  Normally, this feature should be \"enabled,\" but you may disable it at any time, for any amount of time.  (Attacks ongoing will be paused or aborted when you disable this feature.)"}>
                  <InfoSharpIcon style={{fontSize: "20px",}} className={`text-muted`}/>
                </Tooltip>
              </div>

          </Card>

      </div>
  );

}

CIRTControlButton.propTypes = {
  classes: PropTypes.object.isRequired,
  customerId: PropTypes.string,
  overrideEnabledForAdminsStaff: PropTypes.bool,
  requiresModule: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

export default withStyles(styles)(CIRTControlButton);